module.exports = __webpack_public_path__ + "static/media/icon_support.b4b9e953.svg";